import { type ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface EmptyStateProps {
  icon?: ReactNode;
  title: ReactNode;
  description?: ReactNode;
  /** A single next step — an empty panel should always offer one. */
  action?: ReactNode;
  className?: string;
}

/** Placeholder for empty queues, empty hangars and unexplored sectors. */
export function EmptyState({ icon, title, description, action, className }: EmptyStateProps) {
  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center gap-2 px-4 py-8 text-center',
        className,
      )}
    >
      {icon ? <div className="text-content-disabled">{icon}</div> : null}
      <div className="font-display text-xs uppercase tracking-[0.12em] text-content-secondary">
        {title}
      </div>
      {description ? (
        <p className="max-w-xs text-xs leading-relaxed text-content-muted">{description}</p>
      ) : null}
      {action ? <div className="mt-2">{action}</div> : null}
    </div>
  );
}
